/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import { ACTION_TYPES } from '../actions/ActionTypes';

export const initialState = {
  isDataLoaded: false,

  studentFilteredList: [],
   studentDetails:{},
   studentAssessmentDetails:{},
   studentGroups: {},
   studentBaseline: {}

}

const Student = (state = initialState, { type, payload }) => {
  switch(type){

    case ACTION_TYPES.FETCH_STUDENTS:
      return { ...state, studentFilteredList: payload } 
    case ACTION_TYPES.FETCH_STUDENT_DETAILS:
      return { ...state, studentDetails: payload, isDataLoaded:true }
    case ACTION_TYPES.FETCH_STUDENT_ASSESSMENT_DETAILS:
      return { ...state, studentAssessmentDetails: payload, isDataLoaded:true }

    case ACTION_TYPES.FETCH_STUDENT_GROUPS:
      return { ...state, studentGroups: payload, isDataLoaded:true }

      
    case ACTION_TYPES.FETCH_STUDENT_BASELINE:
      return { ...state, studentBaseline: payload}

      
    default:
      return { ...state }
  }
}

export default Student;